import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

import { ButtonRenderProps, Dropdown } from '@/components/Dropdown';

export type Props = {
  onChange: (value: number) => void;
  timePeriod: number;
};

const options = [
  { option: '3', label: '3 Years' },
  { option: '5', label: '5 Years' },
  { option: '10', label: '10 Years' },
];

const DropdownButtonWrapper = ({
  onBlur,
  onFocus,
  onClick,
  innerRef,
  value,
}: ButtonRenderProps) => {
  return (
    <button
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={onClick}
      ref={innerRef}
      className="focus-outline rounded-md"
    >
      <div className="grid grid-cols-[auto_24px] items-center">
        <span className="text-xs font-strong text-softer">{value}</span>
        <span className="sr-only">time period</span>
        <ChevronDownSmallSolid className="fill-softer" />
      </div>
    </button>
  );
};

export const NarrativeMiniValuatorTimePeriodSelector = ({
  onChange,
  timePeriod,
}: Props) => {
  return (
    <Dropdown
      name="narrative-valuator-time-period"
      displayType="inline-block"
      align="right"
      options={options}
      value={timePeriod.toString()}
      onSelect={(value: string) => {
        onChange(parseInt(value, 10));
      }}
      buttonRender={DropdownButtonWrapper}
    />
  );
};
